import React, { useEffect, } from 'react';
import Footer from './Footer';
import Header from './Header';
import SideBar from './SideBar';

import { Outlet, useNavigate } from 'react-router';




function Admin() {
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("usertype") == null) {
            navigate('/');
        }
        else if (localStorage.getItem("usertype") !== "admin") {
            navigate('/');
        }
    }, []);

    return (
        <>

            <Header />
            <SideBar />
            <Outlet />
            <Footer />
        </>
    )
}


export default Admin;